import React from "react";
import { CCard, CCardHeader, CCardBody } from '@coreui/react'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { codeSnippet } from '../../utils/codeSnippet/react/Styles';


function Styles () {
	return (
		<CCard className="mb-4">
			<CCardHeader><strong>Styles</strong></CCardHeader>
			<CCardBody>
				<p><strong>1) Inline Styles:</strong></p>
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code1}</SyntaxHighlighter>	

				<p><strong>2) CSS Stylesheets:</strong></p>
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code2}</SyntaxHighlighter>	
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code3}</SyntaxHighlighter>	

				<p><strong>3) CSS Modules:</strong></p>
				<ul>
					<li><p>CSS Modules scope styles to specific components, preventing unintended style overrides.</p></li>
					<li><p>Class names are transformed into unique strings (e.g., App_module__xk3s3), avoiding global name conflicts.</p></li>
					<li><p>Regular CSS might introduce conflicts when multiple components use the same class names.</p></li>
					<li><p>CSS Modules eliminate this issue by ensuring that styles are isolated to their respective components.</p></li>
				</ul>
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code4}</SyntaxHighlighter>	
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code5}</SyntaxHighlighter>	

				<p><strong>3) SASS / SCSS:</strong></p>
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code6}</SyntaxHighlighter>	
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code7}</SyntaxHighlighter>	

				<p><strong>3) Styled-Components (CSS-in-JS):</strong></p>
				<SyntaxHighlighter language="javascript" style={docco}>{codeSnippet.code8}</SyntaxHighlighter>	
				
			</CCardBody>
		</CCard>			
	)
}

export default Styles